<template>
  <div class="logistics-management">
    <div class="solution-banner">
      <img src="@/assets/images/website/solution/logistics-management/banner.png" />
    </div>
    <div>
      <div class="website-container">
        <Row class="logistics-management-info">
          <Col span="5">
            <img alt src="@/assets/images/website/solution/logistics-management/part_1_1.png" />
          </Col>
          <Col class="info-item" span="3">
            <p>业务管理WEB端</p>
            <p>业务操作移动端</p>
          </Col>
          <Col class="info-item" span="2">
            <img alt src="@/assets/images/website/solution/logistics-management/part_1_2.png" />
          </Col>
          <Col class="info-item" span="3">
            <img alt src="@/assets/images/website/solution/logistics-management/part_1_3.png" />
          </Col>
          <Col class="info-item" span="3">
            <p>出入统计报表</p>
            <p>库存计报表</p>
            <p>调度报表</p>
            <p>报表自定义</p>
          </Col>
          <Col class="info-item" span="6">
            <img alt src="@/assets/images/website/solution/logistics-management/part_1_4.png" />
          </Col>
        </Row>
        <img src="@/assets/images/website/solution/logistics-management/part_1_5.png" style="width:100%;margin-top:10px;" />
        <img src="@/assets/images/website/solution/logistics-management/part_2.png" style="width:100%;margin-top:16px;" />
        <div class="certificate-info ivu-row ivu-row-space-around">
          <img src="@/assets/images/website/solution/logistics-management/part_3_1.png" />
          <img src="@/assets/images/website/solution/logistics-management/part_3_2.png" />
          <img src="@/assets/images/website/solution/logistics-management/part_3_3.png" />
        </div>
        <div class="certificate-info last-info ivu-row ivu-row-space-around">
          <img src="@/assets/images/website/solution/logistics-management/part_3_4.png" />
          <img src="@/assets/images/website/solution/logistics-management/part_3_5.png" />
          <img src="@/assets/images/website/solution/logistics-management/part_3_6.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.solution-banner {
  width: 100%;
  img {
    width: 100%;
    object-fit: cover;
  }
}
.logistics-management-info {
  padding-top: 10px;
  height: 150px;
  img {
    width: 100%;
  }
  .info-item {
    margin: auto 0;
    margin-left: 20px;
    text-align: center;
    align-items: center;
    justify-content: center;
    p {
      font-size: 14px;
      font-weight: bold;
      padding: 4px 0;
      margin: 6px 0;
      background-color: #1f7eff;
      color: #ffffff;
      border-radius: 4px;
    }
  }
}
.certificate-info {
  img {
    width: 400px;
    margin-bottom: 20px;
  }
}
.last-info {
  margin-bottom: 30px;
}
</style>
